import { render, staticRenderFns } from "./productGoodsDetailModal.vue?vue&type=template&id=151ad0f1&scoped=true&"
import script from "./productGoodsDetailModal.vue?vue&type=script&lang=js&"
export * from "./productGoodsDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./productGoodsDetailModal.vue?vue&type=style&index=0&id=151ad0f1&prod&scoped=true&lang=css&"
import style1 from "./productGoodsDetailModal.vue?vue&type=style&index=1&id=151ad0f1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151ad0f1",
  null
  
)

export default component.exports